import { track } from './sendData'

export default class Click {
  constructor(sensors) {
    this._sensors = sensors
  }
  add(entry) {
    // 事件对应的属性对象的json
    const tp = entry.el.attributes['track-params'].value //PS:曝光事件的属性字段要和点击事件的一样

    //内容点击的事件名根据track-event-click来获取；为了应对其他点击需求（事件名和对应的属性不一样），事件名改成动态的。若是没有取到，则默认为ContentClick
    const event = entry.el.attributes['track-event-click'] && entry.el.attributes['track-event-click'].value || 'ContentClick'

    let isClicking = false
    entry.el.addEventListener('click', () => {
      if (isClicking) return
      isClicking = true
      setTimeout(() => {
        isClicking = false
      }, 500)

      // track(this._sensors, 'ContentClick', [tp])
      track(this._sensors, [{event: event, value: tp}])
    })
  }
}
